import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ smooth = true }) => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Si viene con hash (#section), deja que el browser haga el scroll nativo
        if (hash) return;

        const options = smooth ? { top: 0, left: 0, behavior: "smooth" } : { top: 0, left: 0 };
        window.scrollTo(options);
    }, [pathname, hash, smooth]);

    return null;
};

export default ScrollToTop;
